import React from 'react';
import SparkChatBubble from 'components/common/Chats/SparkChatBubble';
import { useBoardNodesContext } from 'hooks/common';
import { useBoardNodesByBoardID } from 'hooks/Board';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';
import { useReactFlowHelpers } from '../SparkOutputBoard/helper/useReactFlowHelpers';
import { AttachmentCardType } from './AttachmentCard';

type Props = {
  chatID: string;
  boardID: string;
  className?: string;
};

function BoardChats({ chatID, boardID, className }: Props) {
  const { selectedNodes, isBoardNodeCollapsedView } = useBoardNodesContext();
  const { idMap: boardNodeIDMap } = useBoardNodesByBoardID(boardID);
  const { handleRemoveNodesFromSelection } = useBoardNodesContext();
  const { idMap } = useBoardNodeTypes();
  const { handleBoardEvent } = useReactFlowHelpers();

  const attachments: AttachmentCardType[] = React.useMemo(() => {
    if (!idMap || !boardNodeIDMap) {
      return [];
    }
    return selectedNodes
      .map((nodeID) => {
        const node = boardNodeIDMap[nodeID];
        if (!node) {
          return null;
        }
        return {
          id: node.id,
          title: node.attributes?.title || 'Untitled',
          cardType: 'boardNode',
          thumbnail:
            node.attributes?.boardNodeTypeID &&
            idMap[node.attributes.boardNodeTypeID]
              ? idMap[node.attributes.boardNodeTypeID].attributes
                  ?.prettyIconURL || ''
              : '',
          details: idMap[node.attributes.boardNodeTypeID].attributes.name,
        };
      })
      .filter(Boolean) as AttachmentCardType[];
  }, [boardNodeIDMap, idMap, selectedNodes]);

  const handleAttachmentRemove = (id: string) => {
    // this should only be called for board nodes
    handleRemoveNodesFromSelection(id);
  };

  return (
    <SparkChatBubble
      chatID={chatID}
      type='board'
      boardID={boardID}
      additionalAttachments={attachments}
      onAttachmentRemove={handleAttachmentRemove}
      className={className}
      handleBoardEvent={handleBoardEvent}
      isBoardNodeCollapsedView={isBoardNodeCollapsedView}
    />
  );
}

export default React.memo(BoardChats);
